// extracted by mini-css-extract-plugin
export default {"separator":"BottomLinks-separator_XE8Oy"};